/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type createThreadPostBody = {
    thread_type: createThreadPostBody.thread_type;
    alert_id: string;
    subject: string;
    users_list: Array<string>;
    email_text: string;
    attached_files: Array<{
        file_name: string;
        file_data: string;
    }>;
    organization_id: string;
};

export namespace createThreadPostBody {
    export enum thread_type {
        ALERT_BASED = 'alert_based',
        GENERIC = 'generic',
    }
}
